import {
  FAVORITES_STORAGE_KEY,
  GROUP_MODE_STORAGE_KEY,
  SETTINGS_STORAGE_KEY,
} from "./config";
import type { BoardSettings, GroupMode } from "./types";

export const defaultSettings = (): BoardSettings => ({
  showHdp: true,
  showTx: true,
  showEu: false,
  showBasic: true,
  showRanking: true,
  showCards: true,
  showPopup: true,
  showOddsChange: true,
  showOdds: true,
  showHt: true,
  showCorners: true,
  followOnTop: true,
  homeSound: "sound1",
  awaySound: "sound2",
});

const readJsonStorage = <T>(key: string, fallback: T): T => {
  try {
    const raw = localStorage.getItem(key);
    return raw ? ({ ...(fallback as any), ...JSON.parse(raw) } as T) : fallback;
  } catch {
    return fallback;
  }
};

const writeJsonStorage = (key: string, value: unknown) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // localStorage can be unavailable in private contexts.
  }
};

export const loadSettings = (): BoardSettings =>
  readJsonStorage(SETTINGS_STORAGE_KEY, defaultSettings());

export const saveSettings = (settings: BoardSettings) =>
  writeJsonStorage(SETTINGS_STORAGE_KEY, settings);

export const loadFavorites = (): Set<string> => {
  try {
    const raw = JSON.parse(localStorage.getItem(FAVORITES_STORAGE_KEY) || "[]");
    return new Set(Array.isArray(raw) ? raw.map(String).filter(Boolean) : []);
  } catch {
    return new Set();
  }
};

export const saveFavorites = (favorites: Set<string>) =>
  writeJsonStorage(FAVORITES_STORAGE_KEY, [...favorites]);

export const loadGroupMode = (fallback: GroupMode = "time"): GroupMode => {
  try {
    const stored = localStorage.getItem(GROUP_MODE_STORAGE_KEY);
    if (stored === "league" || stored === "time") return stored;
    return fallback;
  } catch {
    return fallback;
  }
};

export const saveGroupMode = (mode: GroupMode) => {
  try {
    localStorage.setItem(GROUP_MODE_STORAGE_KEY, mode);
  } catch {
    // localStorage can be unavailable in private contexts.
  }
};
